document.addEventListener('DOMContentLoaded', function () {
	const headerNavbar = document.querySelector('.header__navbar')

	/////////////////////
	// shadow effect on scroll (desktop)
	/////////////////////
	window.addEventListener('scroll', function () {
		if (window.scrollY > 30) {
			headerNavbar.classList.add('header__navbar--JSbox-shadow')
		} else {
			headerNavbar.classList.remove('header__navbar--JSbox-shadow')
		}
	})

	/////////////////////
	// hide desktop nav on scroll down, show on scroll up
	/////////////////////
	const handleNavDuringScroll = () => {
		const nav = document.querySelector('.JShandle-desktop-scroll')
		const header = document.querySelector('.JSheader')

		let lastScrollY = window.scrollY
		const HIDE_OFFSET = 10
		const START_SCROLL = 700

		function onScroll() {
			const currentScrollY = window.scrollY

			if (currentScrollY < START_SCROLL) {
				nav.classList.remove('header__navbar--hide-on-scroll')
				header.classList.remove('header__height-on-scroll')
				lastScrollY = currentScrollY
				return
			}

			if (currentScrollY > lastScrollY + HIDE_OFFSET) {
				nav.classList.add('header__navbar--hide-on-scroll')
				header.classList.add('header__height-on-scroll')
			} else if (currentScrollY < lastScrollY - HIDE_OFFSET) {
				nav.classList.remove('header__navbar--hide-on-scroll')
				header.classList.remove('header__height-on-scroll')
			}
			lastScrollY = currentScrollY
		}

		window.addEventListener('scroll', onScroll, { passive: true })
	}
	handleNavDuringScroll()

	/////////////////////
	// burger menu toggle, and handle mobile nav
	/////////////////////
	const burgerBtn = document.querySelector('.JSburgerBtn')
	const burgerBtnX = document.querySelector('.JSburgerBtn-x')
	const mobileNav = document.querySelector('.JSNav')
	const body = document.querySelector('body')

	// active
	if (burgerBtn && burgerBtnX) {
		burgerBtn.addEventListener('click', () => {
			burgerBtn.classList.add('header__nav-buttons--display-none')
			burgerBtnX.classList.remove('header__nav-buttons--display-none')
			mobileNav.classList.add('header__navigation--mobile-active')
			body.classList.add('header--body-mobile-active')
		})
		// hide
		burgerBtnX.addEventListener('click', () => {
			burgerBtnX.classList.add('header__nav-buttons--display-none')
			burgerBtn.classList.remove('header__nav-buttons--display-none')
			mobileNav.classList.remove('header__navigation--mobile-active')
			body.classList.remove('header--body-mobile-active')
		})
	}

	/////////////////////
	// mobile nav - handle submenus
	/////////////////////
	const mobileNavLinks = document.querySelectorAll('.JSmobile-nav-arrow-down')

	mobileNavLinks.forEach((link) => {
		const submenu = link.nextElementSibling

		if (submenu && submenu.classList.contains('JSmobileSubmenu')) {
			submenu.classList.add('header__navigation-sub--mobile')

			link.addEventListener('click', () => {
				submenu.classList.toggle('header__navigation-sub--mobile-active')
				link.classList.toggle('header__navigation-chevron--mobile-rotate')
			})
		}
	})




}) //end
